import React from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { PrivateRoute } from "./PrivateRoute"
import { publicRoutes, privateRoutes } from "./routes"
import { useAuth } from "hooks/useAuth"

// Public
import { ForgotPasswordPage, ActivateAccountPage, SigninPage } from "features/auth"
import { ErrorPage, ContactPage } from "features/misc"
import NotFound from "router/NotFound"
import NotAuthorized from "router/NotAuthorized"

// Private
import { SearchBikePage, BikePage, BikeUpdatedPage, BicytrustContractsPage } from "features/bike"
import { TeamPage } from "features/Team"
import { HistoryPage } from "features/history"
import {
	PartnerInfo,
	SearchUserPage,
	PartnerCollection,
	PartnerCollectionFolders,
	PartnerPage,
	TeamPartner,
} from "features/Partner"
import { BikeCollectionImport } from "features/BikeCollectionImport"
import { BikeFleet } from "features/bikeFleet/BikeFleet"
import BikeLabelOrder from "features/bikeLabelOrder/BikeLabelOrder"

export const Router = () => {
	const { entity } = useAuth()
	const entityRole = entity?.entity_data?.entity_permission?.role
	return (
		<Routes>
			{/* Public */}
			<Route path={publicRoutes.login.path} element={<SigninPage />} />
			<Route path={publicRoutes.lostPassword.path} element={<ForgotPasswordPage />} />
			<Route path={publicRoutes.activateAccount.path} element={<ActivateAccountPage />} />
			<Route path="/" element={<Navigate to={publicRoutes.login.path} replace={true} />} />

			<Route path={publicRoutes.notFound.path} element={<NotFound />} />

			{/* Public - Bicycode */}
			{/* <Route path={publicRoutes.signup.path} element={<CreateAccount} /> */}

			{/* Protected - Global */}
			<Route element={<PrivateRoute />}>
				<Route
					path={privateRoutes.home.path}
					element={
						entityRole === "MANAGEENTITIES" ? <PartnerCollection /> : <SearchBikePage />
					}
				/>
				<Route path={privateRoutes.error.path} element={<ErrorPage />} />
				<Route path={privateRoutes.notAuthorized.path} element={<NotAuthorized />} />

				{/* Protected - Bike */}
				<Route path={privateRoutes.bikeFleet.path} element={<BikeFleet />} />
				<Route path={privateRoutes.bike.path} element={<BikePage />} />
				<Route path={privateRoutes.searchBike.path} element={<SearchBikePage />} />
				<Route path={privateRoutes.updatedBike.path} element={<BikeUpdatedPage />} />
				<Route path={privateRoutes.bicytrust.path} element={<BicytrustContractsPage />} />

				{/* Protected - Partner / Shop */}
				<Route
					path={privateRoutes.bikeCollectionImport.path}
					element={<BikeCollectionImport />}
				/>
				<Route path={privateRoutes.team.path} element={<TeamPage />} />
				<Route path={privateRoutes.shop.path} element={<PartnerInfo />} />

				{/* Protected - History */}
				<Route path={privateRoutes.history.path} element={<HistoryPage />} />

				{/* Protected - Admin - partner enrolment */}
				<Route path={privateRoutes.addPartner.path} element={<PartnerPage />} />
				<Route path={privateRoutes.partner.path} element={<PartnerPage />} />
				<Route path={privateRoutes.teamPartner.path} element={<TeamPartner />} />
				<Route path={privateRoutes.validatedPartner.path} element={<PartnerCollection />} />
				<Route
					path={privateRoutes.validatePartner.path}
					element={<PartnerCollectionFolders />}
				/>
				<Route path={privateRoutes.bikeLabelOrder.path} element={<BikeLabelOrder />} />

				<Route path={privateRoutes.searchUser.path} element={<SearchUserPage />} />

				<Route path={privateRoutes.contact.path} element={<ContactPage />} />

				{/* Protected - Admin */}
				<Route path={privateRoutes.manageAdmin.path} element={<TeamPage />} />
			</Route>

			<Route path="*" element={<NotFound />} />
		</Routes>
	)
}
